import { Controller } from '@hotwired/stimulus';
import UndistractorOptionStore from '../stores/undistractor_option_store';

export default class extends Controller {
  static values = { serverUserSettings: Array };

  connect() {
    this.store = UndistractorOptionStore.getInstance();
  }

  loadFromExtension(event) {
    const recordsWithDetails = this.#getUndistractorOptionDetails(event.detail);
    this.store.loadFromExtension(recordsWithDetails);
  }

  loadFromServer() {
    const recordsWithDetails = this.#getUndistractorOptionDetails(this.serverUserSettingsValue);
    this.store.loadFromServer(recordsWithDetails);
  }

  #getUndistractorOptionDetails(undistractorOptionSettings) {
    const recordsWithDetails = [];

    undistractorOptionSettings.forEach(([key, value]) => {
      const details = this.#getDetailsFromElement(key, value);
      if (details) {
        recordsWithDetails.push(details);
      }
    });

    return recordsWithDetails;
  }

  #getDetailsFromElement(key, value) {
    const element = this.#elementFromKey(key);
    if (!element) return null;

    const dataset = element.dataset;
    let optionData;

    try {
      optionData = JSON.parse(dataset.undistractorSettingsPageRowUndistractorOptionValue || '{}');
    } catch {
      return null;
    }

    return {
      ...optionData,
      active: value.active,
      schedule: value.schedule,
    };
  }

  #elementFromKey(key) {
    return document.querySelector(`[data-undistractor-extension-undistractor-option-key="${CSS.escape(key)}"]`);
  }
}
